import { observer } from 'mobx-react';
import React from 'react';
import classnames from 'classnames';

import './styles.scss';

type PropsType = {
    children?: React.ReactNode;
    className?: string
};

export const UiModalContent = observer(function UiModalContent({ children, className }: PropsType) {
    return <div className={classnames('ui-new-modal-content', className)}>{children}</div>;
});
